exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-privacy-policy-md": () => import("./../../../src/pages/privacy-policy.md" /* webpackChunkName: "component---src-pages-privacy-policy-md" */),
  "component---src-pages-rules-md": () => import("./../../../src/pages/rules.md" /* webpackChunkName: "component---src-pages-rules-md" */)
}

